// client/src/App.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import BookList from './components/BookList';
import BookDetail from './components/BookDetail';
import Login from './components/Login';
import UserProfile from './components/UserProfile';
import BookRater from './components/BookRater';
import AdminPage from './components/AdminPage'; // <-- NEU importieren

import { UserPreferencesProvider } from './context/UserPreferencesContext';
import { useAuth } from './hooks/useAuth'; // Importieren für PrivateRoute

// PrivateRoute Komponente (optional, aber empfohlen)
function PrivateRoute({ children }) {
  const { token } = useAuth();
  return token ? children : <Navigate to="/" />;
}


function App() {
  return (
    <UserPreferencesProvider>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/booklist" element={ <PrivateRoute> <BookList /> </PrivateRoute> } />
        <Route path="/rate" element={ <PrivateRoute> <BookRater /> </PrivateRoute> } />
        {/* Admin-Route hinzufügen und schützen */}
        <Route path="/admin" element={ <PrivateRoute> <AdminPage /> </PrivateRoute> } />
        {/* Bestehende Routen (ggf. auch schützen) */}
        <Route path="/books/:id" element={ <PrivateRoute> <BookDetail /> </PrivateRoute> } />
        <Route path="/profile" element={ <PrivateRoute> <UserProfile /> </PrivateRoute> } />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </UserPreferencesProvider>
  );
}

export default App;
